import MeaDetailCard from "../../../../components/MeaDetailCard";
import { Image } from "primereact/image";

const TeacherDetailAvatarComponent = ({ teacher }) => {
  return (
    <MeaDetailCard>
      <Image
        src={
          teacher?.member?.avatar
            ? teacher?.member?.avatar + "?u=" + teacher?.member?.updated_at
            : "/user.png"
        }
        zoomSrc={
          teacher?.member?.avatar
            ? teacher?.member?.avatar + "?u=" + teacher?.member?.updated_at
            : "/user.png"
        }
        alt="Image"
        preview
      />
    </MeaDetailCard>
  );
};

export default TeacherDetailAvatarComponent;
